module.exports = __webpack_public_path__ + "static/media/loupe.c9db7247.svg";